import styled from "styled-components";
import React from "react";
import {useTranslation} from "react-i18next";
import {PROJECT_NAME, ProjectName} from "modules";

const BannerWrapper = styled.div`
	width: 100%;
	background-color: #061121;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
`;

const SponsorText = styled.div`
	font-weight: 600;
	font-size: 16px;
	color: #fff;
`;

export const SponsorBanner: React.FC = () => {
	const {t} = useTranslation();
	const showBanner = [ProjectName.GameZone].includes(PROJECT_NAME as ProjectName);

	if (!showBanner) {
		return null;
	}

	return (
		<BannerWrapper>
			<SponsorText>{t("modal.footer.play_zone")}</SponsorText>
		</BannerWrapper>
	);
};
